// @flow @jsx h

import { h, Component } from 'preact'
import { trash } from '../modules/trashController'
import { bem } from '../../lib/bem'
import styles from './Trash.css'

type Props = {
  shouldMount: boolean,
  prefersReducedMotion: boolean,
  width: number,
  height: number,
  onFpsUpdate: Function
}

type State = {
  hasMounted: boolean
}

export class Trash extends Component<Props, State> {
  elm: HTMLDivElement
  state = {
    hasMounted: false
  }
  componentWillUpdate = (nextProps: Props) => {
    if (!this.state.hasMounted && nextProps.shouldMount) {
      this.setState({ hasMounted: true })
      this.mountTrash()
    }
  }

  mountTrash = () => {
    const { elm } = this
    const { width, height, onFpsUpdate } = this.props
    trash(elm, {
      width,
      height,
      onFpsUpdate
    })
  }

  render () {
    const { hasMounted } = this.state
    const { prefersReducedMotion } = this.props

    if (prefersReducedMotion) {
      return (
        <div class={styles.trash__fallback}>
          <div class={styles['trash__fallback-top']} />
          <div class={styles['trash__fallback-body']} />
        </div>
      )
    }

    return (
      <div
        ref={elm => (this.elm = elm)}
        class={bem(styles.trash, hasMounted && 'active')}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Trash.js